import { SignUp } from '@clerk/clerk-react';

const features = [
  'AI-powered market analysis',
  'Real-time risk assessment',
  'Comprehensive reporting',
];

export default function Signup() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-indigo-600 to-purple-700 p-12 items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
        <div className="relative z-10 max-w-md text-white">
          <h1 className="text-5xl font-bold mb-6">
            Get started
            <span className="block text-indigo-200 text-3xl mt-2">Financial AI Analyst</span>
          </h1>
          <p className="text-xl text-indigo-100 mb-8">
            Create your account and start analyzing in minutes
          </p>
          <div className="space-y-4">
            {features.map((feature) => (
              <div key={feature} className="flex items-center space-x-3">
                <div className="flex-shrink-0 w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
                <p className="text-indigo-100">{feature}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right side - Clerk sign-up */}
      <div className="flex-1 flex items-center justify-center p-8">
        <SignUp
          routing="path"
          path="/signup"
          signInUrl="/login"
          forceRedirectUrl="/dashboard"
          appearance={{
            elements: {
              rootBox: 'w-full flex justify-center',
              card: 'shadow-2xl rounded-2xl',
            },
          }}
        />
      </div>
    </div>
  );
}
